export const INGESTION_SOURCES = {
  direct: "API direta",
  hubspot: "HubSpot",
  webinar: "Webinar",
  meetcore: "MeetCore",
} as const;
export const INGESTION_OUTCOMES = {
  success: "Sucesso",
  rejected: "Rejeitada",
  error: "Erro",
} as const;
export type IngestionLogsSearch = ReturnType<typeof ingestionLogsSearch>;
const dateOnly = (value: unknown) => {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return "";
  const parsed = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value
    ? value
    : "";
};
export function ingestionLogsSearch(search: Record<string, unknown>) {
  const pageSize = [25, 50, 100].includes(Number(search.pageSize)) ? Number(search.pageSize) : 25;
  const rawPage = Number(search.page);
  return {
    q: typeof search.q === "string" ? search.q.trim().slice(0, 200) : "",
    source:
      typeof search.source === "string" && Object.hasOwn(INGESTION_SOURCES, search.source)
        ? (search.source as keyof typeof INGESTION_SOURCES)
        : ("" as const),
    outcome:
      typeof search.outcome === "string" && Object.hasOwn(INGESTION_OUTCOMES, search.outcome)
        ? (search.outcome as keyof typeof INGESTION_OUTCOMES)
        : ("" as const),
    from: dateOnly(search.from),
    to: dateOnly(search.to),
    sortBy:
      search.sortBy === "statusCode" || search.sortBy === "durationMs"
        ? search.sortBy
        : ("createdAt" as const),
    sortDir: search.sortDir === "asc" ? ("asc" as const) : ("desc" as const),
    page:
      Number.isInteger(rawPage) && rawPage > 0
        ? Math.min(rawPage, Math.floor(1000000 / pageSize) + 1)
        : 1,
    pageSize,
    selected:
      typeof search.selected === "string" &&
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(search.selected)
        ? search.selected
        : undefined,
  };
}
// As datas na URL são locais; a API recebe instantes que incluem todo o dia final.
export function ingestionLogsParams(filters: IngestionLogsSearch) {
  const params = new URLSearchParams();
  for (const key of ["q", "source", "outcome", "sortBy", "sortDir"] as const)
    if (filters[key]) params.set(key, filters[key]);
  if (filters.from) params.set("from", new Date(`${filters.from}T00:00:00.000`).toISOString());
  if (filters.to) params.set("to", new Date(`${filters.to}T23:59:59.999`).toISOString());
  params.set("limit", String(filters.pageSize));
  params.set("offset", String((filters.page - 1) * filters.pageSize));
  return params.toString();
}
